<template>
	<div>
		<div class="container">
			<div class="handle-box">
			<el-input size="small" v-model="phone" clearable maxlength="12" placeholder="号码" style="width: 180px;" class="handle-input mr10"></el-input>
			<el-select size="small" v-model="status" clearable placeholder="状态" style="width: 150px;" class="handle-select mr10">
				<el-option :value="null" label="全部"></el-option>
				<el-option :value="0" label="待处理"></el-option>
				<el-option :value="1" label="已处理"></el-option>
			</el-select>
			<el-select size="small" v-model="refundStatus" clearable placeholder="退款状态" style="width: 150px;" class="handle-select mr10">
				<el-option :value="null" label="全部"></el-option>
				<el-option :value="false" label="未退款"></el-option>
				<el-option :value="true" label="已退款"></el-option>
			</el-select>
			<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" @click="getData">搜索</el-button>
			<el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus" @click="handleAdd" v-if="isAdmin">充值套餐</el-button>
			<el-button size="small" type="success" :class="[theme]" icon="el-icon-upload2" @click="handleBatchTopUp" v-if="isAdmin">批量充值</el-button>
			<el-button size="small" type="success" :class="[theme]" icon="el-icon-check" @click="handleProcess" v-if="isAdmin">批量处理</el-button>
		</div>
			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }"
				:header-cell-style="{ 'text-align': 'center' }" stripe v-loading="loading" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="phone" label="号码" width="130" align="center"></el-table-column>
				<el-table-column prop="packagesName" label="套餐名称" align="center" show-overflow-tooltip></el-table-column>
				<el-table-column prop="type" label="套餐类型" align="center" width="180">
					<template #default="scope">
						<span v-if="scope.row.type == 0">整月套餐</span>
						<span v-if="scope.row.type == 1">首月上下半月套餐</span>
					</template>
				</el-table-column>
				<el-table-column prop="rechargeAmount" label="用户充值金额" align="center" width="130">
					<template #default="scope">
						<span>{{ scope.row.rechargeAmount }}元</span>
					</template>
				</el-table-column>
				<el-table-column prop="arrivalAmount" label="到账金额" align="center" width="120">
					<template #default="scope">
						<span>{{ scope.row.arrivalAmount }}元</span>
					</template>
				</el-table-column>
				<el-table-column prop="year_month" label="套餐周期" align="center" width="120"></el-table-column>
			<el-table-column prop="status" label="状态" align="center" width="100">
				<template #default="scope">
					<el-tag v-if="scope.row.status == 0" type="warning">待处理</el-tag>
					<el-tag v-if="scope.row.status == 1" type="success">已处理</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="userPhone" label="操作人" align="center" width="130"></el-table-column>
			<el-table-column prop="createdAt" label="创建时间" align="center" width="180">
				<template #default="scope">
					<span>{{ formatDateTime(scope.row.createdAt) }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="processTime" label="到账时间" align="center" width="180">
				<template #default="scope">
					<span>{{ formatDateTime(scope.row.processTime) }}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="80" v-if="isAdmin">
				<template #default="scope">
					<span 
						:class="(!scope.row.refund && scope.row.orderId) ? 'refund-text' : 'disabled-text'"
						@click="(!scope.row.refund && scope.row.orderId) ? handleRefund(scope.row) : null"
					>
						返销
					</span>
				</template>
			</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper"
					:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100]"
					:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
					@current-change="handlePageChange"></el-pagination>
			</div>
		</div>

		<el-dialog title="充值套餐" v-model="addVisible" width="520px" @close="closeDialog">
			<el-form label-width="130px" :model="addForm" ref="editForm">
				<el-form-item label="号码" prop="phone">
					<el-input size="small" v-model="addForm.phone" placeholder="请输入号码"></el-input>
				</el-form-item>
				<el-form-item label="套餐名称" prop="packagesName">
					<el-select size="small" v-model="addForm.packagesName" placeholder="请选择套餐" style="width: 100%;" @change="handlePackageChange">
						<el-option v-for="item in packagesList" :key="item.id" :label="item.packagesName" :value="item.packagesName"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="套餐类型" prop="type" v-if="currentPackage">
					<span>{{ currentPackage.type == 0 ? '整月套餐' : '首月上下半月套餐，次月整月' }}</span>
				</el-form-item>
				<el-form-item label="当前周期" prop="period" v-if="currentPackage">
					<span>{{ period == 0 ? '上半月' : '下半月' }}</span>
				</el-form-item>
				<el-form-item label="用户充值金额" prop="rechargeAmount" v-if="currentPackage">
					<span>{{ rechargeAmount }}元</span>
				</el-form-item>
				<el-form-item label="到账金额" prop="arrivalAmount" v-if="currentPackage">
					<span>{{ arrivalAmount }}元</span>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="submitAdd">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog title="批量充值套餐" v-model="batchVisible" width="1000px" @close="closeBatchDialog">
			<div class="batch-dialog-content">
				<!-- 输入区域 -->
				<div class="batch-input-section">
					<el-input 
						type="textarea" 
						v-model="batchPhones" 
						placeholder="请输入号码，每行一个"
						:rows="5"
						class="batch-textarea">
					</el-input>
					<el-button 
						type="primary" 
						:class="[theme]" 
						@click="batchQuery"
						:loading="batchQueryLoading"
						style="margin-top: 10px;">
						查询
					</el-button>
				</div>

				<!-- 查询结果表格 -->
				<el-table 
					:data="batchResult" 
					border 
					class="batch-table"
					max-height="400"
					v-loading="batchQueryLoading">
					<el-table-column prop="phone" label="号码" width="130" align="center"></el-table-column>
					<el-table-column prop="state" label="号码状态" width="120" align="center">
						<template #default="scope">
							<span :style="{color: scope.row.state && scope.row.state.includes('待激活') ? '#ff6600' : '#3dbf15'}">
								{{ scope.row.state || '查询失败' }}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="ORDER_NAME" label="套餐名称" align="center" show-overflow-tooltip></el-table-column>
					<el-table-column prop="packageAmount" label="套餐金额" width="100" align="center">
						<template #default="scope">
							<span v-if="scope.row.packageAmount">{{ scope.row.packageAmount }}元</span>
							<span v-else>-</span>
						</template>
					</el-table-column>
					<el-table-column prop="actualRechargeAmount" label="实际充值金额" width="120" align="center">
						<template #default="scope">
							<span v-if="scope.row.actualRechargeAmount" style="color: #ff0000; font-weight: bold;">
								{{ scope.row.actualRechargeAmount }}元
							</span>
							<span v-else>-</span>
						</template>
					</el-table-column>
					<el-table-column label="是否可充值" width="100" align="center">
						<template #default="scope">
							<span :style="{color: scope.row.canRecharge ? '#3dbf15' : '#ff0000', fontWeight: 'bold'}">
								{{ scope.row.canRecharge ? '可充值' : '不可充值' }}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="rechargeTip" label="提示" align="center" show-overflow-tooltip></el-table-column>
				</el-table>

				<!-- 汇总信息 -->
				<div class="batch-summary" v-if="batchResult.length > 0">
					<span class="summary-item">可充值数量：<strong style="color: #3dbf15;">{{ rechargeCount }}</strong> 个</span>
					<span class="summary-item">总充值金额：<strong style="color: #ff0000; font-size: 18px;">{{ totalAmount }}</strong> 元</span>
				</div>

				<!-- 操作按钮 -->
				<div class="batch-actions">
					<el-button size="small" @click="batchVisible = false">取消</el-button>
					<el-button 
						size="small" 
						type="primary" 
						:class="[theme]" 
						@click="confirmBatchTopUp"
						:loading="batchSubmitLoading"
						:disabled="rechargeCount === 0">
						确认充值（{{ rechargeCount }}个号码，共{{ totalAmount }}元）
					</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getDxtPackagesOfNumber,
		packageTopUp,
		getPackageTopUpRecord,
		processPackageTopUp,
		refundPackageTopUp,
		batchPhoneInfo,
		batchTopUp
	} from '../api/dijia.js';
	export default {
		name: 'DxtPackageTopUp',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				phone: '',
				status: null,
				refundStatus: null,
				query: {
					pageIndex: 1,
					pageSize: 10,
					userId: localStorage.getItem('user')
				},
				tableData: [],
				pageTotal: 0,
				packagesList: [],
				addForm: {
					phone: '',
					packagesName: ''
				},
				addVisible: false,
				currentPackage: null,
				period: 0,
				rechargeAmount: 0,
				arrivalAmount: 0,
				selectedIds: [],
				isAdmin: false,
				isCompany: false,
				isAgent: false,
				// 批量充值相关
				batchVisible: false,
				batchPhones: '',
				batchResult: [],
				batchQueryLoading: false,
				batchSubmitLoading: false
			};
		},

		created() {
			let role = localStorage.getItem('ms_role');
			if (role === 'company') {
				this.isCompany = true;
			}
			if (role === 'admin') {
				this.isAdmin = true;
			}
			if (role === 'agent') {
				this.isAgent = true;
			}
			this.getData();
			this.getPackagesList();
			this.calculatePeriod();
		},
		
		computed: {
			// 可充值数量
			rechargeCount() {
				return this.batchResult.filter(r => r.canRecharge).length;
			},
			// 总充值金额
			totalAmount() {
				return this.batchResult
					.filter(r => r.canRecharge && r.actualRechargeAmount)
					.reduce((sum, r) => sum + parseFloat(r.actualRechargeAmount || 0), 0)
					.toFixed(2);
			}
		},
		
		methods: {
			calculatePeriod() {
				const today = new Date();
				const day = today.getDate();
				this.period = day <= 15 ? 0 : 1;
			},
			formatDateTime(dateStr) {
				if (!dateStr) return '';
				const date = new Date(dateStr);
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			getPackagesList() {
				getDxtPackagesOfNumber().then(res => {
					if (res?.code === 200) {
						this.packagesList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getData() {
			this.loading = true;
			let params = {
				phone: this.phone,
				status: this.status,
				refundStatus: this.refundStatus,
				pageIndex: this.query.pageIndex,
				pageSize: this.query.pageSize
			};
			getPackageTopUpRecord(params).then(res => {
				this.loading = false;
				if (res?.code === 200) {
					this.tableData = res.data.list;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
			});
		},
			handleAdd() {
				this.addVisible = true;
				this.addForm = {
					phone: '',
					packagesName: ''
				};
				this.currentPackage = null;
				this.rechargeAmount = 0;
				this.arrivalAmount = 0;
			},
			handlePackageChange(packagesName) {
				this.currentPackage = this.packagesList.find(item => item.packagesName === packagesName);
				if (this.currentPackage) {
					if (this.currentPackage.type === 0) {
						this.rechargeAmount = this.currentPackage.sjtxPrice;
						this.arrivalAmount = this.currentPackage.dxtPrice;
					} else {
						if (this.period === 0) {
							this.rechargeAmount = this.currentPackage.sjtxPrice;
							this.arrivalAmount = this.currentPackage.dxtPrice;
						} else {
							this.rechargeAmount = this.currentPackage.sjtxPrice / 2;
							this.arrivalAmount = this.currentPackage.dxtPrice / 2;
						}
					}
				}
			},
			submitAdd() {
				if (!this.addForm.phone) {
					this.$message.error('号码不能为空');
					return;
				}
				if (!this.addForm.packagesName) {
					this.$message.error('套餐名称不能为空');
					return;
				}
				let data = {
					phone: this.addForm.phone,
					packagesName: this.addForm.packagesName,
					userPhone: localStorage.getItem('ms_username')
				};
				packageTopUp(data).then(res => {
					if (res?.code === 200) {
						this.$message.success('充值申请提交成功');
						this.getData();
					} else {
						this.$message.error(res.message);
					}
					this.addVisible = false;
				});
			},
			closeDialog() {
				this.addVisible = false;
			},
			handleSelectionChange(selection) {
				this.selectedIds = selection.map(item => item.id);
			},
			handleProcess() {
				if (this.selectedIds.length === 0) {
					this.$message.error('请选择要处理的记录');
					return;
				}
				this.$confirm('确定要批量处理选中的记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					processPackageTopUp(this.selectedIds.join(',')).then(res => {
						if (res?.code === 200) {
							this.$message.success('处理成功');
							this.getData();
							this.selectedIds = [];
						} else {
							this.$message.error(res.message);
						}
					});
				}).catch(() => {});
			},
			handleSizeChange(val) {
			this.query.pageSize = val;
			this.getData();
		},
		handlePageChange(val) {
			this.query.pageIndex = val;
			this.getData();
		},
		// 批量充值相关方法
		handleBatchTopUp() {
			this.batchVisible = true;
			this.batchPhones = '';
			this.batchResult = [];
		},
		closeBatchDialog() {
			this.batchVisible = false;
			this.batchPhones = '';
			this.batchResult = [];
		},
		batchQuery() {
			// 解析输入的号码（按换行分隔）
			const phones = this.batchPhones
				.split('\n')
				.map(p => p.trim())
				.filter(p => p);
			
			if (phones.length === 0) {
				this.$message.error('请输入至少一个号码');
				return;
			}
			
			this.batchQueryLoading = true;
			this.batchResult = [];
			
			batchPhoneInfo(phones).then(res => {
				this.batchQueryLoading = false;
				if (res?.code === 200) {
					this.batchResult = res.data;
					this.$message.success('查询完成');
				} else {
					this.$message.error(res.message || '查询失败');
				}
			}).catch(err => {
				this.batchQueryLoading = false;
				this.$message.error('查询失败，请稍后再试');
				console.error(err);
			});
		},
		confirmBatchTopUp() {
			if (this.rechargeCount === 0) {
				this.$message.error('没有可充值的号码');
				return;
			}
			
			this.$confirm(`确定要充值 ${this.rechargeCount} 个号码，总金额 ${this.totalAmount} 元吗？`, '提示', {
				confirmButtonText: '确定充值',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.batchSubmitLoading = true;
				
				// 只充值 canRecharge=true 的号码
				const rechargeList = this.batchResult.filter(r => r.canRecharge);
				
				batchTopUp({
					phones: rechargeList,
					userId: localStorage.getItem('user')
				}).then(res => {
					this.batchSubmitLoading = false;
					if (res?.code === 200) {
						this.$message.success(res.message || '批量充值成功');
						this.closeBatchDialog();
						this.getData(); // 刷新列表
					} else {
						this.$message.error(res.message || '批量充值失败');
					}
				}).catch(err => {
					this.batchSubmitLoading = false;
					this.$message.error('批量充值失败，请稍后再试');
					console.error(err);
				});
			}).catch(() => {});
		},
		handleRefund(row) {
			this.$confirm(`确定要返销号码 ${row.phone} 的充值记录吗？返销后该号码可以更换套餐。`, '提示', {
				confirmButtonText: '确定返销',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$message.info('正在处理返销，请稍候...');
				refundPackageTopUp({ recordId: row.id }).then(res => {
					if (res?.code === 200) {
						this.$message.success('返销成功');
						this.getData();
					} else {
						this.$message.error(res.message || '返销失败');
					}
				}).catch(err => {
					this.$message.error('返销失败，请稍后再试');
					console.error(err);
				});
			}).catch(() => {});
		}
	}
};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}
	
	.refund-text {
		color: #f56c6c;
		cursor: pointer;
		font-size: 14px;
		transition: color 0.3s;
	}
	
	.refund-text:hover {
		color: #f23434;
		text-decoration: underline;
	}
	
	.disabled-text {
		color: #c0c4cc;
		cursor: not-allowed;
		font-size: 14px;
	}
	
	/* 批量充值对话框样式 */
	.batch-dialog-content {
		padding: 10px 0;
	}
	
	.batch-input-section {
		margin-bottom: 20px;
	}
	
	.batch-textarea {
		width: 100%;
	}
	
	.batch-table {
		margin-bottom: 20px;
	}
	
	.batch-summary {
		background: #f5f7fa;
		padding: 15px 20px;
		border-radius: 4px;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.summary-item {
		font-size: 14px;
		color: #606266;
	}
	
	.batch-actions {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
	}
</style>
